import type { FaireProductEntity } from "../../entity_types/product";

export const p_dcj36qympd: FaireProductEntity = {
  token: "p_dcj36qympd",
  type: "product",
  name: "FLOWER - Bracelet Charms",
  brandToken: "b_pm9cgrtuwg",
  brandName: "Mack & Rex",
  imageUrl:
    "https://cdn.faire.com/fastly/172eb85b5de4b3c82087b12b352470de34e9398ac64bdacd5ef6312c5ef19622.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/807e66ca6125f81b6eac72e035fd98258705ab5bc59082dedb6245c2f1a97f09.jpeg",
    "https://cdn.faire.com/fastly/3fc533bf5cd555125e000266473ee7e4980c63c40dc0f3b66cd7d4f44e0c42c2.jpeg",
    "https://cdn.faire.com/fastly/83a223d4e6af430f3d742faeaf3e3c3c7b5f8a68faa1fc2418eb2a29df098722.jpeg",
  ],
  priceDollars: 6,
  description:
    "These super cute bracelet charms are perfect for adding to any DIY Bracelet! These charms include a ton of different colors of adorable flowers! Perfect for kids and teens who love to make, imagine, and create something uniquely theirs!\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:27.472Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
